import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 520,
  name: 'Web Server Returns Unknown Error',
  description:
    'A Cloudflare-specific status code meaning the origin server returned an empty, unknown, or unexpected response that Cloudflare could not process. This is not a standard HTTP status code — it exists only in the Cloudflare ecosystem.',
  causes: [
    'The origin server returned an empty response (no headers, no body) or closed the connection before sending anything.',
    'The origin server returned response headers that exceed Cloudflare\'s 32KB header size limit, or the headers are malformed.',
    'The origin server crashed mid-response, returning a partial or corrupted HTTP response that Cloudflare cannot parse.',
  ],
  fixes: [
    'Check origin server logs for errors. A 520 is Cloudflare telling you something is wrong on your server — the real error is in your server logs, not Cloudflare\'s.',
    'Reduce response header size. Remove excessively large cookies, debug headers, or unnecessary custom headers that push total header size over 32KB.',
    'Ensure your origin server completes responses properly. If the server process is crashing, check for out-of-memory errors or unhandled exceptions.',
  ],
  monitoringTip:
    'If you use Cloudflare, a 520 indicates your origin server is misbehaving. Uptrack detects these Cloudflare-specific errors and alerts you, even though they are not standard HTTP codes.',
}

export const Route = createFileRoute('/_site/http/520')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
